<template>
  <div class="segment-trim">
    <span class="segment-trim__label">片头/片尾裁剪（秒）</span>
    <div class="segment-trim__inputs">
      <el-input-number
        :value="headTrimSeconds"
        :min="0"
        :max="maxTrim"
        :disabled="disabled"
        size="small"
        controls-position="right"
        @change="onHeadChange"
      />
      <span>~</span>
      <el-input-number
        :value="tailTrimSeconds"
        :min="0"
        :max="maxTrim"
        :disabled="disabled"
        size="small"
        controls-position="right"
        @change="onTailChange"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'SegmentTrimInput',
  props: {
    headTrimSeconds: { type: Number, default: 0 },
    tailTrimSeconds: { type: Number, default: 0 },
    maxDurationSeconds: { type: Number, default: 0 },
    disabled: { type: Boolean, default: false },
  },
  computed: {
    maxTrim() {
      if (!this.maxDurationSeconds) return 3600;
      return Math.max(0, this.maxDurationSeconds - 1);
    },
  },
  methods: {
    onHeadChange(value) {
      this.$emit('update:headTrimSeconds', value || 0);
    },
    onTailChange(value) {
      this.$emit('update:tailTrimSeconds', value || 0);
    },
  },
};
</script>

<style scoped>
.segment-trim {
  margin-top: 12px;
}
.segment-trim__label {
  display: block;
  margin-bottom: 8px;
  font-size: 13px;
  color: #374151;
}
.segment-trim__inputs {
  display: flex;
  align-items: center;
  gap: 8px;
}
</style>
